import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "../../utils/apis";

export const getDocuments = createAsyncThunk(
  "DocumentDetails/getDocuments",
  async (data, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = getState();
      const rsp = await API.postApi(
        `Registration/GetDocuments`,
        {},
        data,
        token
      );
      return rsp.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const GetManualUtilizador = createAsyncThunk(
  "DocumentDetails/GetManualUtilizador",
  async () => {
    try {
      const rsp = await API.getApi(
        "Registration/GetManualUtilizador"
      );

      return rsp.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

export const getDocumentsLinks = createAsyncThunk(
  "DocumentDetails/getlinkfiles",
  async (fileName, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.getApi(
        `Registration/GetDocument/${fileName}`,
        {},
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);
export const GetProfileImages = createAsyncThunk(
  "DocumentDetails/GetProfileImages",
  async (fileName, { getState }) => {
    try {
      const {
        auth: {
          user: { token },
        },
      } = await getState();

      const res = await API.getApi(
        `Registration/GetProfileImages/${fileName}`,
        {},
        token
      );
      return res.data;
    } catch (error) {
      // rejectWithValue(error.response.data);
      throw new Error(error);
    }
  }
);

const initialState = {
  loading: false,
  status: "idle",
  documents: [],
  documentCount: 0,
  documentOffset: 0,
  documentLimit: 10,
  documentStatus: "",
  documentPage: 1,
  invalidDocument: {},
  confirmationDocumentDialog:false,
  documentLink: null,
};

export const documentDetailsSlice = createSlice({
  name: "DocumentDetails",
  initialState: initialState,
  reducers: {
    resetDocumentDetails: (state) => {
      state = initialState;
    },
    setDocumentOffset: (state, action) => {
      state.entitiesOffset = action.payload;
    },
    setDocumentLimit: (state, action) => {
      state.entitiesLimit = action.payload;
    },
    setDocumentPage: (state, action) => {
      state.entitiesPage = action.payload;
    },
    setConfirmationDocumentDialog: (state, action) => {
      state.confirmationDocumentDialog = action.payload;
    },
    setInvalidDocumentData: (state, action) => {
      state.invalidDocument = action.payload;
    },
    setInvalidDocument: (state, action) => {
      state.invalidDocument = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder 
      .addCase(getDocuments.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(getDocuments.fulfilled, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.documents = action.payload.documents.documents;
        state.documentCount = action.payload.documents.totalCount;
      })
      .addCase(getDocuments.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.documents = [];
        state.documentCount = 0;
      })
      .addCase(GetManualUtilizador.pending, (state, action) => {
        state.status = "in-progress";
        state.loading = true;
      })
      .addCase(GetManualUtilizador.fulfilled, (state) => {
        state.status = "idle";
        state.loading = false;
      })
      .addCase(GetManualUtilizador.rejected, (state, action) => {
        state.status = "idle";
        state.loading = false;
        state.documents = [];
        state.documentCount = 0;
      })
      .addCase(getDocumentsLinks.pending, (state) => {
        state.loading = true;
        state.documentLink = null;
      })
      .addCase(getDocumentsLinks.fulfilled, (state, action) => {
        state.loading = false;
        state.documentLink = action.payload;
      })
      .addCase(getDocumentsLinks.rejected, (state) => {
        state.loading = false;
        state.documentLink = null;
      })
      .addCase(GetProfileImages.pending, (state) => {
        state.loading = true;
        state.documentLink = null;
      })
      .addCase(GetProfileImages.fulfilled, (state, action) => {
        state.loading = false;
        state.documentLink = action.payload;
      })
      .addCase(GetProfileImages.rejected, (state) => {
        state.loading = false;
        state.documentLink = null;
      });
      
  },
});

export const {
  setDocumentOffset,
  setDocumentLimit,
  setDocumentPage,
  setInvalidDocumentData,
  setInvalidDocument,
  setConfirmationDocumentDialog
} = documentDetailsSlice.actions

export default documentDetailsSlice.reducer;
